export var CardType;
(function (CardType) {
    CardType["CREDIT_CARD"] = "creditCards";
    CardType["GIFT_CARD"] = "giftCards";
    CardType["CHECKING_ACCOUNT"] = "checkingAccounts";
    CardType["KEY_TAG"] = "keyTags";
    CardType["PRO_XTRA_DOLLARS"] = "proxPerksCard";
    CardType["PAYPAL_ACCOUNT"] = "payPalAccounts";
    CardType["PRO_HOUSE_ACCOUNT"] = "proHouseAccount";
})(CardType || (CardType = {}));
export const NULLIFY_FIELD = 'NULLIFY_FIELD';
export const cardTypeSearchMapping = {
    [CardType.CREDIT_CARD]: 'creditDebitCard',
    [CardType.GIFT_CARD]: 'giftCard',
    [CardType.CHECKING_ACCOUNT]: 'checkingAccount',
    [CardType.PAYPAL_ACCOUNT]: 'PAYPAL',
    [CardType.PRO_XTRA_DOLLARS]: 'proXtrareloadableCard',
};
export var T2CStatus;
(function (T2CStatus) {
    T2CStatus["ENROLLED"] = "ENROLLED";
    T2CStatus["PENDING"] = "PENDING";
})(T2CStatus || (T2CStatus = {}));
export const HDPASS_URL_PARAM = 'hdwallet';
